import type { PricingVersionTuple } from '../../model/model.ts'

import type { FrRcpaxePricingVersionFormat } from './model.ts'

export const frRcpaxePricingVersions = [
  ['pricing-fr-rcp-axeria-1.0.0-2026-10-04', { label: 'Version 1' }],
  ['pricing-fr-rcp-axeria-1.0.1-2027-01-01', { label: 'Version 1.0.1 - Terrorism tax €8.50' }],
] as const satisfies PricingVersionTuple<FrRcpaxePricingVersionFormat>[]

export type FrRcpaxePricingVersion = (typeof frRcpaxePricingVersions)[number][0]
